/**
 * detectIne5Duplicate.ts — Detección de INE5 duplicado en sesión
 *
 * Utilidades puras para detectar si un municipio ya fue cargado en la
 * sesión actual. Se usan en WizardPageV2 para avisar al técnico cuando
 * intenta cargar un segundo documento con el mismo código INE5.
 *
 * @module utils
 * @version 1.0.0
 * @task C1 (N1.07 Plan Mejoras ODT)
 */

/**
 * Comprueba si el INE5 ya está registrado en el conjunto de la sesión.
 * Devuelve `true` (duplicado) solo si `ine5` es no vacío y ya existe.
 */
export function isIne5Duplicate(
  loadedSet: ReadonlySet<string>,
  ine5: string | null | undefined
): boolean {
  if (!ine5 || ine5.trim() === '') return false;
  return loadedSet.has(ine5.trim());
}

/**
 * Devuelve un nuevo Set con el INE5 añadido.
 * No muta el conjunto original (inmutable para facilitar testing).
 */
export function addIne5ToSession(
  loadedSet: ReadonlySet<string>,
  ine5: string | null | undefined
): Set<string> {
  const next = new Set(loadedSet);
  if (ine5 && ine5.trim()) {
    next.add(ine5.trim());
  }
  return next;
}
